export const oneSearchDiscoveryBase = '/discovery'
export const oneSearchDiscoveryResults = `${oneSearchDiscoveryBase}/results`
export const allCollections = '/all-collections'
export const oneSearchV2Results = `${allCollections}/results`
export const recentSearches = `${allCollections}/searches`
